import {
  ConfigValue,
  configTypes,
  ConfigActionTypes,
  ErrorValue
} from './types'

const actions = {
  setConfigValue: (payload: ConfigValue): ConfigActionTypes => ({
    type: configTypes.SET_CONFIG_VALUE,
    payload
  }),
  switchUserType: (): ConfigActionTypes => ({
    type: configTypes.SWITCH_USER_TYPE,
    payload: null
  }),
  setError: (payload: ErrorValue): ConfigActionTypes => ({
    type: configTypes.SET_ERROR,
    payload
  }),
  setMenuOpen: (payload: boolean): ConfigActionTypes => ({
    type: configTypes.SET_MENU_OPEN,
    payload
  })
}

export default actions
